import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const buildBundleUrl = (endpoint) =>
  `${API_ROUTES.TRANSPORT.BASE}${API_ROUTES.TRANSPORT.COMPANIES}/${endpoint ? endpoint : ""}`

export const companiesService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCompanies: builder.query({
      query: () => ({
        url: buildBundleUrl("filtered-list"),
        method: "GET",
      }),
    }),
  }),
})

export const { useGetCompaniesQuery, useLazyGetCompaniesQuery } = companiesService
